export default {
  core: {
    auth: {
      login: '/login',
      logout: '/logout',
      forgottenPassword: '/password/email/',
      passwordReset: '/password/reset'
    },
    agencies: {
      withId: function (id) {
        return '/api/agencies/' + id
      },
      users: function (id) {
        return '/api/agencies/' + id + '/users'
      }
    },
    agencySettings: {
      withId: function (id) {
        return '/api/agency-settings/' + id
      },
      updateFileWithId: function (id) {
        return '/api/agency-settings/update-file/' + id
      }
    },
    answers: {
      root: '/api/answers',
      self: '/api/answers/self',
      withId: function (id) {
        return '/api/answers/' + id
      }
    },
    candidates: {
      root: '/api/candidates',
      self: '/api/self',
      updatePassword: '/api/candidates/updatePassword',
      candidateRegister: '/candidate-register',
      candidateSignature: '/candidate-signature',
      candidateInvite: '/api/candidates/invite',
      candidateSync: '/api/candidates/sync',
      uncensor: '/api/candidates/uncensor/',
      withId: function (id) {
        return '/api/candidates/' + id
      },
      signup: function (id) {
        return '/api/candidate/update/' + id
      }
    },
    candidateDetails: {
      root: '/api/candidate-details/',
      withId: function (id) {
        return '/api/candidate-details/' + id
      },
      emailUser: function (id) {
        return '/api/candidate-details/send-email/' + id
      },
      adminEmail: function () {
        return '/api/candidate-details/admin-email'
      }
    },
    countries: {
      root: '/api/countries'
    },
    forms: {
      root: '/api/forms',
      copy: '/api/forms/copy',
      publish: '/api/forms/publish',
      disable: '/api/forms/disable',
      historical: '/api/forms/historical',
      sendForm: '/api/forms/send-form',
      restore: function (id) {
        return '/api/forms/restore/' + id
      },
      withId: function (id) {
        return '/api/forms/' + id
      },
      answers: function (id) {
        return '/api/forms/' + id + '/answers'
      },
      candidateAnswers: function (formId, candidateId) {
        return '/api/forms/' + formId + '/answers/' + candidateId
      }
    },
    templates: {
      root: '/api/templates',
      copy: '/api/templates/copy',
      withId: function (id) {
        return '/api/templates/' + id
      }
    },
    questions: {
      root: '/api/questions/',
      withId: function (id) {
        return '/api/questions/' + id
      },
      types: '/api/question-types/'
    },
    sections: {
      root: '/api/sections/',
      withId: function (id) {
        return '/api/sections/' + id
      }
    },
    documents: {
      root: '/api/documents',
      grouped: '/api/document-categories',
      withId: function (id) {
        return '/api/documents/' + id
      }
    },
    pdf: {
      withId: function (formId, candidateId) {
        return '/api/pdf/' + formId + '/' + candidateId
      }
    },
    settings: {
      root: '/api/settings',
      withId: function (id) {
        return '/api/settings/' + id
      }
    },
    industries: {
      root: '/api/industries',
      withId: function (id) {
        return '/api/industries/' + id
      }
    },
    users: {
      root: '/api/users',
      self: '/api/self',
      updatePassword: '/api/users/updatePassword',
      withId: function (id) {
        return '/api/users/' + id
      }
    }
  }
}
